import { render, staticRenderFns } from "./ImageInfo.vue?vue&type=template&id=176edb55"
import script from "./ImageInfo.vue?vue&type=script&lang=js"
export * from "./ImageInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports